import React, { useMemo, useCallback } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

/**
 * Problems modal — shows save-blocking validation issues.
 * Legacy parity: frmProblems.vb (display list of issues; single Close button).
 * UI-consistency rewrite using reactstrap. Props unchanged.
 */
const ProblemsModal = ({ open, problems = [], onClose }) => {
  const safeProblems = useMemo(
    () => (Array.isArray(problems) ? problems : []),
    [problems]
  );
  const hasProblems = safeProblems.length > 0;

  const handleClose = useCallback(() => {
    onClose?.();
  }, [onClose]);

  return (
    <Modal isOpen={!!open} toggle={handleClose} centered scrollable>
      <ModalHeader toggle={handleClose}>
        <i className="ri-error-warning-line align-bottom me-2 text-warning"></i>
        Problems
      </ModalHeader>
      <ModalBody>
        {!hasProblems ? (
          <div className="text-muted fst-italic">No problems to display.</div>
        ) : (
          <ul className="ps-3 mb-0">
            {safeProblems.map((p, i) => (
              <li key={i} className="mb-2">
                {p}
              </li>
            ))}
          </ul>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default React.memo(ProblemsModal);
